import { type ColumnDef } from "@tanstack/react-table";
import { type ReactNode } from "react";
import {
  ActionsHeader,
  SelectAllCheckbox,
  SelectRowCheckbox,
} from "./columnCells";

export function createSelectColumn<T>(): ColumnDef<T, unknown> {
  return {
    id: "select",
    size: 24,
    enableSorting: false,
    enableColumnFilter: false,
    enableResizing: false,
    header: SelectAllCheckbox,
    cell: SelectRowCheckbox,
  };
}

interface Action<T> {
  icon: ReactNode;
  onClick: (row: T) => void;
  label?: string;
}

export function createActionsColumn<T>(
  actions: Action<T>[],
): ColumnDef<T, unknown> {
  return {
    id: "actions",
    header: ActionsHeader,
    enableSorting: false,
    enableColumnFilter: false,
    enableResizing: false,
    cell: ({ row }) => (
      <div className="flex items-center gap-1">
        {actions.map((action, i) => (
          <button
            key={i}
            type="button"
            onClick={() => action.onClick(row.original)}
            className="cursor-pointer rounded p-1.5 text-muted-foreground transition-colors hover:bg-muted"
            aria-label={action.label}
          >
            {action.icon}
          </button>
        ))}
      </div>
    ),
  };
}
